// extracted by mini-css-extract-plugin
export default {"SearchPanel":"pl_a bhl_ea bhl_kb bhl_js bhl_a bhl_j bhl_sm bhl_sn","SearchPanel__icon":"pl_b bhl_vm bhl_hg bhl_ss bhl_uy","SearchPanel__input":"pl_c bhl_iz bhl_eb bhl_z"};